import { styled, Switch } from "@mui/material";

export const styles = {
  slide: (selectedButton, id) => {
    return {
      cursor: "pointer",
      background: selectedButton === id ? "#FFFFFF" : "transparent",
      color: selectedButton === id ? "#333333" : "#757B93",
      fontSize: "14px",
      borderRadius: selectedButton === id ? "6px" : 0,
      fontWeight: 400,
      padding: "3px 10px",
      textTransform: "none",
    };
  },
  hideScroll: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    pb: 4,
  },
  pagination: {
    "& .MuiPaginationItem-root": {
      borderRadius: "8px",
      color: "#666666",
      fontWeight: 500,
      padding: 0,
      "&.Mui-selected": {
        backgroundColor: "#F1F4FA",
        color: "#666666",
        border: 0,
        padding: 0,
      },
    },
  },
  paginationButtons: {
    textTransform: "capitalize",
    borderColor: "#CCD2DE",
    color: "#666666",
    fontWeight: 500,
    fontSize: 12,
    borderRadius: 2,
    padding: "4px 20px",
    "&:hover": { borderColor: "#CCD2DE" },
  },
  paginationContainer: {
    paddingX: 1.5,
    pt: 1.5,
    gap: 2,
    alignItems: "center",
  },
  removeBtn: {
    color: "#FFFFFF",
    marginRight: 1,
    backgroundColor: "#ef5350",
    padding: "13px 10px",
    borderRadius: 2,
    textTransform: "none",
    fontSize: 13,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#f44336",
    },
  },
  addBtn: {
    textTransform: "none",
    color: "#656E7F",
    border: 0,
    backgroundColor: "#F1F4FA",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 2,
    padding: "4px 10px",
    "&:hover": {
      transition: "width 0.5s ease-in-out",
      border: 0,
    },
  },
  voiceCard: {
    border: "1px solid #CCD2DE",
    borderRadius: 2,
    maxHeight: "340px",
    transition: "height 0.3s ease-in-out",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F0F0F0",
    },
  },
  hoveredModelCard: {
    pt: 2,
    width: 350,
    position: "relative",
    borderRadius: 2,
    boxShadow: 3,
  },
  selectField: {
    fontSize: 13,
    fontWeight: 500,
    borderColor: "#CCD2DE",
    borderRadius: 1,
    color: "#333333",
    "& .MuiSelect-select": {
      padding: "11px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 2,
    },
  },
  voicesContainer: {
    bgcolor: "#F1F4FA",
    mt: 0.5,
    borderRadius: 1.5,
    display: "inline-flex",
    gap: 1,
    flexWrap: "nowrap",
    overflowX: "auto",
    maxWidth: "100%",
    scrollbarWidth: "none",
  },
  loadingContainer: {
    position: "absolute",
    top: 0,
    width: "95%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  viewVoicesButton: {
    padding: "8px 0",
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 2,
    textTransform: "none",
  },
  voiceGridContainer: {
    px: 1,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 1,
  },
  voiceStatusContainer: {
    px: 2,
    py: 1,
    borderTop: 1,
    borderBottom: 1,
    borderColor: "#D1D9EF",
  },
  voiceCardContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))",
    gap: 1,
    gridAutoFlow: "dense",
    paddingRight: 1,
  },
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 38,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#4280FF",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 15,
    height: 15,
  },
  "& .MuiSwitch-track": {
    borderRadius: 24 / 2,
    backgroundColor: "#A9A9BC",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
